// ARQUIVO ATUALIZADO E CORRIGIDO
// --- INÍCIO DA ALTERAÇÃO: Alterado a extensão dos arquivos de .png para .jpg ---
import avatar1 from '../assets/avatars/avatar1.jpg';
import avatar2 from '../assets/avatars/avatar2.jpg';
import avatar3 from '../assets/avatars/avatar3.jpg';
import avatar4 from '../assets/avatars/avatar4.jpg';
// --- FIM DA ALTERAÇÃO ---

export const avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
];